import React from 'react'
import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { APARTMENT_DETAIL } from '../../urls'
import ApartmentUpdate from './ApartmentUpdate'
import Button from '../../components/common/Button'

export default function ApartmentItem({ item, apartment, index }) {
    const productRemove = useDeleteRequest({ url: APARTMENT_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            apartment.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <ApartmentUpdate
            clients={apartment}
            item={item}
            onCancel={() => {
                apartment.request()
                hideUpdateModal()
            }}
        />,
    )

    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{item.entrance}</td>
            <td className="is-size-6">{(item.apartmentNumber)} - хона</td>
            <td className="is-size-6">{(item.totalPrice)} Сўм</td>
            <td className="is-size-6">{(item.initialPayment)} Сўм</td>
            <td className="is-size-6">{(item.months)} ой</td>
            <td className="is-size-6">{(item.monthlyPayment)} Сўм</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small"
                        icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>

    )
}
